// AboutUs.js
import React from 'react';
import Layout from './Layout'; // Import the Layout component
const AboutUs = () => {
  return (
  <Layout pageTitle ="About Us">
    <div className="container mt-5">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <p>
            <strong>Transaction Services (TrxServices)</strong> is a leading provider in the electronic
            payments industry. Headquartered with operations in Atlanta, Georgia and additional facilities in Denver,
            Colorado, Transaction Services has longevity and experience in the payments industry.
          </p>
          <h6>Company Mission:</h6>
          <p>
            Transaction Services mission is to provide a single technical infrastructure that securely
            addresses the full merchant life-cycle while automating the Agent’s residual payment and
            reporting. Transaction Services superior design will reinvent the merchant sales experience
            thereby achieving record growth.
          </p>
          <p>
            Our core business is transaction processing. As a result, our focus and efforts are dedicated
            to delivering superior products and outstanding service to our customers.
          </p>
        </div>
      </div>
    </div>
    </div>
    </Layout>
  );
};

export default AboutUs;
